module.exports = __webpack_public_path__ + "img/34.f92821c9.png";